import { render, staticRenderFns } from "./PrivateContent.vue?vue&type=template&id=449cdc98&scoped=true&"
import script from "./privateContent.ts?vue&type=script&lang=ts&"
export * from "./privateContent.ts?vue&type=script&lang=ts&"
import style0 from "./PrivateContent.vue?vue&type=style&index=0&id=449cdc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449cdc98",
  null
  
)

export default component.exports